import { render, staticRenderFns } from "./Page7.vue?vue&type=template&id=4c765954&scoped=true&"
import script from "./Page7.vue?vue&type=script&lang=js&"
export * from "./Page7.vue?vue&type=script&lang=js&"
import style0 from "./Page7.vue?vue&type=style&index=0&id=4c765954&prod&lang=css&"
import style1 from "./Page7.vue?vue&type=style&index=1&id=4c765954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c765954",
  null
  
)

export default component.exports